import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/eu-map-green.jpg")